(function(win) {
  'use strict';

  var listeners = [],
  doc = win.document,
  MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
  observer;

  function ready(selector, fn) {
      listeners.push({
          selector: selector,
          fn: fn
      });
      if (!observer) {
          // Watch for changes in the document
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
              childList: true,
              subtree: true
          });
      }
      // Check if the element is currently in the DOM
      check();
  }

  function check() {
      // Check the DOM for elements matching a stored selector
      for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
          listener = listeners[i];
          // Query for elements matching the specified selector
          elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
              element = elements[j];
              // Make sure the callback isn't invoked with the
              // same element more than once
              if (!element.ready) {
                  element.ready = true;
                  // Invoke the callback with the element
                  listener.fn.call(element, element);
              }
          }
      }
  }

  // Expose `ready`
  win.ready = ready;

})(this);


// Move Insta Arrows

ready('.instafeed-new-arrow-prev', function(element) {
  const arrowPrevToMove = document.querySelector('.instafeed-new-arrow-prev');
  const arrowNextToMove = document.querySelector('.instafeed-new-arrow-next');
  const referenceElement = document.querySelector('.instafeed-new-carousel-container');

  //const newParent = document.getElementById('insta-feed');
  //newParent.appendChild(arrowPrevToMove);

  referenceElement.parentNode.insertBefore(arrowPrevToMove, referenceElement);
  referenceElement.parentNode.insertBefore(arrowNextToMove, referenceElement);
});


// Touch

var body = document.getElementsByTagName('body')[0];
if ( !("ontouchstart" in body) ) {
    body.className += (body.className?" ":"") + "no-touch";
} else {
    body.className += (body.className?" ":"") + "has-touch";
}


// Menu hover

if ( !("ontouchstart" in body) ) {
  let items = document.querySelector(".list-menu--inline").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {

      const myTimeout = setTimeout(hover, 50);

      function hover() {

        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

      }

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        clearTimeout(myTimeout);
      });

    });
  });
}


// Mobile Menu Close

document.getElementById("menu-drawer__icon--close").addEventListener("click", function() {
  var element = document.getElementById("Details-menu-drawer-container");
  element.classList.remove("menu-opening");
  element.removeAttribute("open");
  document.querySelector(".header__icon--menu").setAttribute("aria-expanded", "false");
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
});


// Brand Slider

var brandSlider = document.querySelector('.brand-slider-wrapper');
if ( brandSlider ){
  var flkty = new Flickity( brandSlider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: false,
    autoPlay: 3000,
    pauseAutoPlayOnHover: false
  });
}


// Landing Product Slider

var productSlider = document.querySelector('.page-products .grid');
if ( productSlider ){
  var flkty = new Flickity( productSlider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: false,
    autoPlay: false,
    pauseAutoPlayOnHover: false
  });
}


// Featured Collection Slider
/*
var featuredSlider = document.querySelector('.featured-collection-silder .product-grid');
var flkty = new Flickity( featuredSlider, {
  // options
  cellAlign: 'left',
  contain: true,
  wrapAround: true,
  pageDots: false,
  autoPlay: 3000,
  pauseAutoPlayOnHover: false
});
*/


// Size guide scroll

if ( document.getElementById("size-guide") ){
  document.getElementById("size-guide").addEventListener("click", function() {
    var scrollDiv = document.getElementById("product-tabs").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
  
    var getAttr = document.getElementById("tab-Size-Guide").getAttribute('aria-expanded');
    if (getAttr === "false"){
      document.getElementById("tab-Size-Guide").click();
    }
  });
}
